import { all, fork } from 'redux-saga/effects';

import approvalActionBookingSaga from './Bookings/AirportTransfer/ApprovalAction/saga';
import assignChauffeurSaga from './Bookings/AirportTransfer/AssignChauffeur/saga';
import bookingAssignToMeSaga from './Bookings/AirportTransfer/AssignToMe/saga';
import assignVendorSaga from './Bookings/AirportTransfer/AssignVendor/saga';
import assignVendorRemarksSaga from './Bookings/AirportTransfer/AssignVendorRemarksList/saga';
import bulkBookingConfirmationByVendorSaga from './Bookings/AirportTransfer/BulkBookingConfirm/saga';
import cancelBookingByAdminSaga from './Bookings/AirportTransfer/CancelBookingByAdmin/saga';
import cancelBookingByVendorSaga from './Bookings/AirportTransfer/CancelBookingByVendor/saga';
import cancellationRemarksForVendorSaga from './Bookings/AirportTransfer/CancellationRemarksForVendor/saga';
import completeBookingSaga from './Bookings/AirportTransfer/CompleteBooking/saga';
import confirmBookingByVendorSaga from './Bookings/AirportTransfer/ConfirmBookingByVendor/saga';
import createChauffeurSaga from './Bookings/AirportTransfer/CreateChauffeur/saga';
import getBookingDetailsSaga from './Bookings/AirportTransfer/GetBookingDetails/saga';
import getBookingsListSaga from './Bookings/AirportTransfer/GetBookingsList/saga';
import getCarsListOfVendorSaga from './Bookings/AirportTransfer/GetCarsListOfVendor/saga';
import getChauffeursListSaga from './Bookings/AirportTransfer/GetChauffeursList/saga';
import getFiltersListSaga from './Bookings/AirportTransfer/GetFiltersList/saga';
import getFilterValuesSaga from './Bookings/AirportTransfer/GetFilterValues/saga';
import getVendorsListSaga from './Bookings/AirportTransfer/GetVendorsList/saga';
import modifyBookingSaga from './Bookings/AirportTransfer/ModifyBooking/saga';
import showModifyFieldsSaga from './Bookings/AirportTransfer/ModifyFields/saga';
import nudgeDriverSaga from './Bookings/AirportTransfer/NudgeDriver/saga';
import getAvailableVehiclesSaga from './Bookings/AirportTransfer/GetAvailableVehicles/saga';
import changeVehicleSaga from './Bookings/AirportTransfer/ChangeVehicle/saga';
import raiseDisputeSaga from './Bookings/AirportTransfer/RaiseDispute/saga';
import getBookingTypeForGlobalSearchSaga from './Bookings/GetBookingType/saga';
import getBookingGlobalSearchSaga from './Bookings/GetGlobalSearchBooking/saga';
import watchBookingTypeSaga from './BookingType/saga';
import watchV2DashboardSaga from './Dashboard/saga';
import postDownloadDumpAdminV2Saga from './DownloadDump/saga';
import addReasonSaga from './DynamicReason/AddReason/saga';
import getActionByStatusSaga from './DynamicReason/GetActionByStatus/saga';
import getReasonByActionsSaga from './DynamicReason/GetReason/saga';
import remarkStatusDetailsSaga from './DynamicReason/GetRemarkStatus/saga';
import updateReasonSaga from './DynamicReason/UpdateReason/saga';
import bookingDumpTypeListSaga from './GetBookingDumpTypeList/saga';
import getDownlaodDumpListSaga from './GetDownloadDumpList/saga';
import watchUserRolesSaga from './UserRole/saga';

import getAirportsBasedOnConfigSaga from './AirportTransferBooking/Airports/saga';
import getAutoCompleteLocationSaga from './AirportTransferBooking/AutoCompleteLocation/saga';
import createAirportTransferBookingSaga from './AirportTransferBooking/CreateAirportTransferBooking/saga';
import createGuestUserSaga from './AirportTransferBooking/CreateGuestUser/saga';
import getBookingSummaryDataSaga from './AirportTransferBooking/GetBookingSummary/saga';
import getGuestUsersSaga from './AirportTransferBooking/GetGuestUsers/saga';
import getPaymentSummarySaga from './AirportTransferBooking/GetPaymentSummary/saga';
import getRecentSearchesSaga from './AirportTransferBooking/RecentSearches/saga';
import createUpdateGuestSaga from './AirportTransferBooking/UpdateGuestUser/saga';
import getValidateFlightDetailsSaga from './AirportTransferBooking/ValidateFlightDetails/saga';
import getValidateLocationSaga from './AirportTransferBooking/ValidateLocation/saga';

import getProjectCampaignSaga from './CampaignManagement/GetCampaignProject/saga';
import membershipsRequestApprovalSaga from './CampaignManagement/MembershipsApproval/saga';

import getDigitalOffersSaga from './DigitalBookingManagement/GetDigitalOffers/saga';
import getDigitalAuthMethodsSaga from './DigitalBookingManagement/GetDigitalAuthMethods/saga';
import getDigitalCardStatesSaga from './DigitalBookingManagement/GetDigitalCardStates/saga';
import createOutletSaga from './OutletManagement/CreateOutlet/saga';
import getOutletsSaga from './OutletManagement/GetOutlets/saga';
import getOutletDetailsSaga from './OutletManagement/GetOutletDetails/saga';
import getOutletStatusCountsSaga from './OutletManagement/GetOutletStatusCounts/saga';
import updateOutletSaga from './OutletManagement/UpdateOutlet/saga';
import getOutletFiltersSaga from './ValidationManagement/GetOutletFilters/saga';
import verifyCouponSaga from './ValidationManagement/VerifyCoupon/saga';

export function* bookingsSagas() {
  yield all([
    fork(assignVendorRemarksSaga),
    fork(cancelBookingByVendorSaga),
    fork(assignVendorSaga),
    fork(createChauffeurSaga),
    fork(confirmBookingByVendorSaga),
    fork(bookingAssignToMeSaga),
    fork(getBookingsListSaga),
    fork(getDigitalOffersSaga),
    fork(getDigitalAuthMethodsSaga),
    fork(getDigitalCardStatesSaga),
    fork(createOutletSaga),
    fork(getOutletsSaga),
    fork(getOutletDetailsSaga),
    fork(getOutletStatusCountsSaga),
    fork(updateOutletSaga),
    fork(getOutletFiltersSaga),
    fork(verifyCouponSaga),
    fork(getCarsListOfVendorSaga),
    fork(assignChauffeurSaga),
    fork(getFilterValuesSaga),
    fork(getFiltersListSaga),
    fork(cancellationRemarksForVendorSaga),
    fork(getVendorsListSaga),
    fork(getChauffeursListSaga),
    fork(getBookingDetailsSaga),
    fork(watchBookingTypeSaga),
    fork(watchV2DashboardSaga),
    fork(watchUserRolesSaga),
    fork(cancelBookingByAdminSaga),
    fork(getBookingTypeForGlobalSearchSaga),
    fork(getBookingGlobalSearchSaga),
    fork(showModifyFieldsSaga),
    fork(modifyBookingSaga),
    fork(approvalActionBookingSaga),
    fork(remarkStatusDetailsSaga),
    fork(getActionByStatusSaga),
    fork(getReasonByActionsSaga),
    fork(addReasonSaga),
    fork(updateReasonSaga),
    fork(completeBookingSaga),
    fork(nudgeDriverSaga),
    fork(getAvailableVehiclesSaga),
    fork(changeVehicleSaga),
    fork(raiseDisputeSaga),
    fork(bookingDumpTypeListSaga),
    fork(postDownloadDumpAdminV2Saga),
    fork(getDownlaodDumpListSaga),
    fork(bulkBookingConfirmationByVendorSaga),

    fork(getAirportsBasedOnConfigSaga),
    fork(getAutoCompleteLocationSaga),
    fork(createAirportTransferBookingSaga),
    fork(createGuestUserSaga),
    fork(getBookingSummaryDataSaga),
    fork(getGuestUsersSaga),
    fork(getPaymentSummarySaga),
    fork(getRecentSearchesSaga),
    fork(createUpdateGuestSaga),
    fork(getValidateFlightDetailsSaga),
    fork(getValidateLocationSaga),
    fork(getProjectCampaignSaga),
    fork(membershipsRequestApprovalSaga),
  ]);
}

export default bookingsSagas;
